module.exports = __webpack_public_path__ + "static/img/image_news_over_02.a8f07b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_02.png
// module id = mNN4
// module chunks = 10